var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3333 29.3333H34.6667V2.66667C34.6667 1.95942 34.3857 1.28115 33.8856 0.781049C33.3855 0.280952 32.7072 0 32 0V0C31.2928 0 30.6145 0.280952 30.1144 0.781049C29.6143 1.28115 29.3333 1.95942 29.3333 2.66667V29.3333H2.66667C1.95942 29.3333 1.28115 29.6143 0.781049 30.1144C0.280952 30.6145 0 31.2928 0 32H0C0 32.7072 0.280952 33.3855 0.781049 33.8856C1.28115 34.3857 1.95942 34.6667 2.66667 34.6667H29.3333V61.3333C29.3333 62.0406 29.6143 62.7189 30.1144 63.219C30.6145 63.7191 31.2928 64 32 64C32.7072 64 33.3855 63.7191 33.8856 63.219C34.3857 62.7189 34.6667 62.0406 34.6667 61.3333V34.6667H61.3333C62.0406 34.6667 62.7189 34.3857 63.219 33.8856C63.7191 33.3855 64 32.7072 64 32C64 31.2928 63.7191 30.6145 63.219 30.1144C62.7189 29.6143 62.0406 29.3333 61.3333 29.3333Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPlus);
export default __webpack_public_path__ + "static/media/fi-rr-plus.edae62e9b133e9e9daf5c6f838e8ad6e.svg";
export { ForwardRef as ReactComponent };